import { firstValueFrom } from 'rxjs';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { TimeOffService } from '@app/main/time-off/services/time-off.service';
import { AppConsts } from '@shared/AppConsts';
import { CommonCacheServiceProxy, FilerMeberDataDto, GetAllProjectDto, ProjectServiceProxy, ProjectType5, UserListDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ConstRoleName } from '@shared/ConstRoleNames';
@Component({
    standalone: false,
    selector: 'app-member-filter',
    templateUrl: './member-filter.component.html',
    styleUrls: ['./member-filter.component.css']
})
export class MemberFilterComponent extends AppComponentBase implements OnInit {

    items: FilerMeberDataDto[]=[];
    @Output() change = new EventEmitter<UserListDto[]>();
    @Input() inputUseritems: UserListDto[];
    noDataFound: boolean = false;
    // Input properties
    @Input() multiselect: boolean;
    @Input() closeOnSelect: boolean;
    @Input() placeholder: string;
    @Input() shortName: boolean;
    @Input() roleName: boolean;
    @Input() incomingProjectsIds: number[];
    @Input() AddTimeOff: boolean = false;
    @Input() isdisabled: boolean;
    /** When true, loads all tenant members (e.g. Company Profile email recipients) instead of project-scoped users. */
    @Input() useTenantMembers: boolean = false;
    // Non input properties
    bindLabel: string = "emailAddress";
    @Input() selectedItems: any;
    selectedItemsLength:number=0;
    isOpen: boolean;
    loading: boolean = false;
    showselectall: boolean = true;
    showdeselectall: boolean = false;
    assignedUserIdFilter: number[];
    projectsData: GetAllProjectDto[];
    projectIds: number[] = [];
    membersList: UserListDto[] = [];
    userRoleArray: string[];
    isEmployee:boolean;
    constructor(
        private _userServiceProxy: UserServiceProxy,
        private timeOffService: TimeOffService,
        private _abpSessionService: AbpSessionService,
        private _commonCacheServiceProxy: CommonCacheServiceProxy,
        injector:Injector,
        private _projectServiceProxy: ProjectServiceProxy,) {
            super(injector);
    }

    async ngOnInit() {
        if (this.inputUseritems !== undefined && this.inputUseritems !== null) {
            this.selectedItems = this.inputUseritems;
        }
        this.loading = true;

        this.getAllProjects();

        this.loading = false;
    }

    async getAllProjects() {

        this.userRoleArray = AppConsts.userRoleArray;
        this.isEmployee = this.userRoleArray.includes(ConstRoleName.User);
        if (this.useTenantMembers) {
            this.items = await firstValueFrom(this._commonCacheServiceProxy.filterByMemberData());
            this.items.forEach(x => {
                x.roleNames = x.roleNames?.map(role => this.l(role));
            });
            this.items = this.items.sort((a, b) => a.fullName.localeCompare(b.fullName));
            return;
        }
        if(this.AddTimeOff){
            const isUserAdmin = this.userRoleArray.includes(ConstRoleName.Admin);
            const isUserManager = this.userRoleArray.includes(ConstRoleName.ProjectManager);
            const isUserPrManager = this.userRoleArray.includes(ConstRoleName.ProgramManager);
            const isUserSuper = this.userRoleArray.includes(ConstRoleName.SuperAdmin);

            if (isUserAdmin || isUserSuper) {
                this.items = await firstValueFrom( this._commonCacheServiceProxy.filterByMemberData());
            }
            else if(isUserManager||isUserPrManager){
                this.assignedUserIdFilter = [];
                this.projectsData = [];
                this.assignedUserIdFilter.push(this._abpSessionService.userId);
                let res = await firstValueFrom(this._projectServiceProxy.getProjectsByUserIds(this.assignedUserIdFilter, ProjectType5.AllProjects,undefined, undefined, false).pipe(finalize(() => {
                })));
                this.projectsData = res;
                this.projectIds = this.projectsData.map((team) => team.id);
                await this._userServiceProxy.getAllUsersUnderProject(this.projectIds).subscribe(async res => {
                    this.items = res;
                    if(this.items.length==0){
                        this.items = await firstValueFrom( this._commonCacheServiceProxy.filterByMemberData());
                        this.items = this.items.filter(x=>x.id ==this._abpSessionService.userId);
                    }

                });
            }
            else{
                this.assignedUserIdFilter = [];
                this.projectsData = [];
                this.assignedUserIdFilter.push(this._abpSessionService.userId);
                this.multiselect =false;
                this.closeOnSelect = true;
                this.items = await firstValueFrom( this._commonCacheServiceProxy.filterByMemberData());
                this.items = this.items.filter(x=>x.id ==this._abpSessionService.userId);
            this.selectedItems = this.items;
                this.change.emit(this.selectedItems);
            }

        }
        else{
            const isUserAdmin = this.userRoleArray.includes(ConstRoleName.Admin);

            if (isUserAdmin) {
                this.items = await firstValueFrom( this._commonCacheServiceProxy.filterByMemberData());
                this.items.forEach(x=>{
                    x.roleNames = x.roleNames.map(x=>this.l(x));
                })
            }
        else {
            this.assignedUserIdFilter = [];
            this.projectsData = [];
            this.assignedUserIdFilter.push(this._abpSessionService.userId);
            let res = await firstValueFrom(this._projectServiceProxy.getProjectsByUserIds(this.assignedUserIdFilter, ProjectType5.AllProjects,undefined, undefined, false).pipe(finalize(() => {
            })));
            this.projectsData = res;
            this.projectIds = this.projectsData.map((team) => team.id);
            await this._userServiceProxy.getAllUsersUnderProject(this.projectIds).subscribe( res => {
                this.items = res;
            });
        }
     }
     this.items = this.items.sort((a, b) => a.fullName.localeCompare(b.fullName));
    }

    emitSelection() {

        if (!this.selectedItems)
            return;
        if(this.selectedItemsLength!=undefined){
        this.selectedItemsLength = this.selectedItems?.length;
        if (this.selectedItems?.length != this.items?.length) {
            this.showselectall = true;
            this.showdeselectall = false;
        } else {
            this.showselectall = false;
            this.showdeselectall = true;
        }
    }
        this.change.emit(this.selectedItems);
    }

    selectAll() {
        this.selectedItems = [...this.items];
        this.showselectall = false;
        this.showdeselectall = true;
        this.change.emit(this.selectedItems);
    }

    unselectAll() {
        this.selectedItems = [];
        this.showselectall = true;
        this.showdeselectall = false;
        this.change.emit(this.selectedItems);
    }

    rearrangeItems() {
    }

    clearSelection() {
        this.selectedItems = undefined;
        this.change.emit(this.selectedItems);
    }

    customSearchFn(term: string, item: UserListDto) {
        return item.fullName.toLowerCase().indexOf(term.toLowerCase()) > -1 || item.emailAddress.toLowerCase().indexOf(term.toLowerCase()) > -1;
    }

    checkUncheck(item: any | undefined) {
        if (item && item.hasOwnProperty('selected')) {
          item.selected = !item.selected;
        }
      }

    setNoDataFound(value) {
        this.noDataFound = value;
    }

}
